import { render, staticRenderFns } from "./MessageList.bkp.vue?vue&type=template&id=caeb8a18&"
import script from "./MessageList.bkp.vue?vue&type=script&lang=js&"
export * from "./MessageList.bkp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports